<template>
<div class="outer">
    <div class="child">
        <el-divider content-position="center">音乐拾光</el-divider>
            <home-music></home-music>
        <el-divider content-position="center"></el-divider>
    </div>
</div>
</template>

<script>
import HomeMusic from '@/pages/Home/components/Music'
export default {
  name: 'Home',
  components: {
    HomeMusic
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.outer {
  padding: 10%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.child{
  width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/newHome.vue